import { datadogLogs } from '@datadog/browser-logs';
import { createBrowserStorage } from './createBrowserStorage';
import { migrateLegacy } from './migrateLegacy';
import { createWebStoragePort, onWindowStorageChange } from './webStoragePort';

const local = createWebStoragePort(() => window.localStorage);

/** Browser Storage da aplicação. Em testes, `jest.setup.js` troca este módulo pelo adapter em memória. */
export const browserStorage = createBrowserStorage({
	local,
	session: createWebStoragePort(() => window.sessionStorage),
	now: () => Date.now(),
	log: (event, context) => datadogLogs.logger.warn(event, context),
	onExternalChange: onWindowStorageChange,
});

/** Roda uma vez no boot do navegador, antes de qualquer leitor depender do legado. */
export const migrateLegacyBrowserStorage = () =>
	migrateLegacy(browserStorage, local);
